import { render, staticRenderFns } from "./SalidaInventarioComponent.vue?vue&type=template&id=060df960&"
import script from "./SalidaInventarioComponent.vue?vue&type=script&lang=js&"
export * from "./SalidaInventarioComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports